import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/lib/supabase'
import { useAuth } from './useAuth'

export function useTeam() {
  const { user, loading: authLoading } = useAuth()
  const [team, setTeam] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchTeam = useCallback(async () => {
    if (!user?.id) {
      return
    }
    
    const userId = user.id // Capture the ID
    
    try {
      setLoading(true)
      setError(null)
      
      const { data, error } = await supabase
        .from('teams')
        .select('*')
        .eq('user_id', userId)
        .maybeSingle() // Use maybeSingle() instead of single() to handle no results gracefully

      if (error) {
        // Only throw non-404 errors
        if (error.code !== 'PGRST116') {
          throw error
        }
      }
      
      setTeam(data)
    } catch (err) {
      setError(err.message)
      setTeam(null)
    } finally {
      setLoading(false)
    }
  }, [user?.id]) // Only depend on the ID, not the whole user object

  useEffect(() => {
    
    // If auth is still loading, keep team loading true
    if (authLoading) {
      setLoading(true)
      return
    }
    
    // If auth is done but no user, set loading false
    if (!user?.id) {
      setTeam(null)
      setLoading(false)
      return
    }

    fetchTeam()
  }, [user?.id, authLoading, fetchTeam])

  const refetch = useCallback(() => {
    fetchTeam()
  }, [fetchTeam])

  return {
    team,
    loading,
    error,
    refetch,
    hasTeam: !!team,
  }
}

